import {CemitedClass} from "./cemitedClass.ts";

export abstract class Unidentified extends CemitedClass implements Unidentified {
    id?: string;
    // TODO sourceKey is being removed from the frontend. Use id instead of identification
    sourceKey?: string;
    name?: string;
    description?: string;
}
